import { useState, useEffect } from "react";
import { Coffee, ArrowRight, Heart } from "lucide-react";

export default function TransactionFlow() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setStep(1), 800);
    const t2 = setTimeout(() => setStep(2), 2400);
    const t3 = setTimeout(() => setStep(3), 3800);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, []);

  return (
    <div className="txflow">
      <div className="txflow__card">
        <div className="txflow__header">
          <span className="txflow__label">Live transaction</span>
          <span className="txflow__time">Just now</span>
        </div>

        {/* Step 1 — purchase */}
        <div className={`txflow__row txflow__fade ${step >= 1 ? "txflow__fade--in" : ""}`}>
          <div className="txflow__icon-wrap">
            <Coffee size={20} />
          </div>
          <div className="txflow__info">
            <p className="txflow__merchant">Morning coffee</p>
            <p className="txflow__sub">Blue Bottle Coffee</p>
          </div>
          <span className="txflow__amount">$4.25</span>
        </div>

        {/* Divider */}
        <div className={`txflow__divider txflow__divider--scale ${step >= 2 ? "txflow__divider--in" : ""}`} />

        {/* Step 2 — round-up */}
        <div className={`txflow__roundup txflow__fade ${step >= 2 ? "txflow__fade--in" : ""}`}>
          <div className="txflow__roundup-left">
            <div className="txflow__icon-wrap txflow__icon-wrap--red">
              <ArrowRight size={15} />
            </div>
            <div>
              <p className="txflow__sub">Rounded to</p>
              <p className="txflow__rounded-val">$5.00</p>
            </div>
          </div>
          <div className={`txflow__change-pill txflow__pop ${step >= 2 ? "txflow__pop--in" : ""}`}>
            <span className="txflow__change">+$0.75</span>
          </div>
        </div>

        {/* Divider 2 */}
        <div className={`txflow__divider txflow__divider--green txflow__divider--scale ${step >= 3 ? "txflow__divider--in" : ""}`} />

        {/* Step 3 — distribution */}
        <div className={`txflow__dist txflow__fade ${step >= 3 ? "txflow__fade--in" : ""}`}>
          <div className="txflow__dist-header">
            <div className="txflow__icon-wrap txflow__icon-wrap--green">
              <Heart size={14} />
            </div>
            <p className="txflow__sub">Distributed to your artist mix</p>
          </div>
          <div className="txflow__avatars">
            {["R", "S", "NF"].map((initial, i) => (
              <div
                key={initial}
                className={`txflow__avatar txflow__pop ${step >= 3 ? "txflow__pop--in" : ""}`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <span>{initial}</span>
              </div>
            ))}
            <span className={`txflow__causes txflow__fade ${step >= 3 ? "txflow__fade--in" : ""}`}
              style={{ transitionDelay: "500ms" }}>
              +2 causes
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
